import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/corner-right-up.svg'


const _withScopeId = n => (_pushScopeId("data-v-505f8998"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nps-group-list"
}
const _hoisted_2 = { class: "gl-navbar" }
const _hoisted_3 = { class: "gl-back" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Up one level",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "truncate"
}
const _hoisted_6 = { class: "gl-sort" }
const _hoisted_7 = { class: "gl-sort-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gl-select",
  class: "gl-select-text"
}, "Sorted by:", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "asc" }, "Low to High", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "desc" }, "High to Low", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gl-select-caret" }, null, -1))
const _hoisted_14 = { class: "gl-table" }
const _hoisted_15 = {
  key: 0,
  class: "gl-label-row"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, " ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, " ", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "gl-group-name" }
const _hoisted_20 = { class: "gl-group-comparison" }
const _hoisted_21 = { class: "gl-group-nps" }
const _hoisted_22 = { class: "responded" }
const _hoisted_23 = { class: "field-title" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "gl-group-name" }
const _hoisted_26 = { class: "gl-group-comparison" }
const _hoisted_27 = { class: "gl-group-nps" }
const _hoisted_28 = { class: "responded" }
const _hoisted_29 = {
  key: 3,
  class: "gl-no-results"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "99" }, "No results found", -1))
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NPSBarLabel = _resolveComponent("NPSBarLabel")!
  const _component_NPSBar = _resolveComponent("NPSBar")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_ctx.tsGroupSummary && _ctx.tsGroupSummary.tsgroups)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.previousTeamScoreboard)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goUpOneLevel && _ctx.goUpOneLevel(...args)))
                }, [
                  _hoisted_4,
                  (_ctx.previousTeamScoreboard)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Back to " + _toDisplayString(_ctx.previousTeamScoreboard.parentFieldLabel
                                ? _ctx.previousTeamScoreboard.parentFieldLabel + ': '
                                : '') + " " + _toDisplayString(_ctx.previousTeamScoreboard.parentGroups.length > 0 &&
                            _ctx.previousTeamScoreboard.parentGroups.join('...') !==
                                ''
                                ? _ctx.previousTeamScoreboard.parentGroups.join(
                                      '...'
                                  )
                                : 'All'), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("select", {
                id: "gl-select",
                class: "gl-select-text",
                value: _ctx.tsSort,
                onInput: _cache[1] || (_cache[1] = (event) => _ctx.setTsSort(event.target.value))
              }, _hoisted_12, 40, _hoisted_9),
              _hoisted_13
            ])
          ])
        ]),
        _createElementVNode("table", _hoisted_14, [
          (!_ctx.emptyList)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("td", null, [
                  _createVNode(_component_NPSBarLabel, {
                    min: Number(_ctx.tsGroupSummary.minNPS),
                    max: Number(_ctx.tsGroupSummary.maxNPS),
                    average: Number(_ctx.tsGroupSummary.averageNPS)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" AVG " + _toDisplayString((
                                Math.round(_ctx.tsGroupSummary.averageNPS * 10) / 10
                            ).toFixed(1)), 1)
                    ], undefined, true),
                    _: 1
                  }, 8, ["min", "max", "average"])
                ]),
                _hoisted_17
              ]))
            : _createCommentVNode("", true),
          (_ctx.fields.length <= 1)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.sortedGroups, (currentGroup) => {
                return _withDirectives((_openBlock(), _createElementBlock("tr", {
                  key: currentGroup.group,
                  class: _normalizeClass({
                        'gl-group': true,
                        'gl-grid-hover':
                            currentGroup.group === _ctx.tsGridHoverGroup,
                        'selected-leaf': _ctx.isSelectedLeaf(currentGroup),
                    }),
                  onClick: ($event: any) => (_ctx.selectGroup(currentGroup))
                }, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(currentGroup.group), 1),
                  _createElementVNode("td", _hoisted_20, [
                    _createVNode(_component_NPSBar, {
                      nps: Number(currentGroup.NPS),
                      min: Number(_ctx.tsGroupSummary.minNPS),
                      max: Number(_ctx.tsGroupSummary.maxNPS),
                      average: Number(_ctx.tsGroupSummary.averageNPS)
                    }, null, 8, ["nps", "min", "max", "average"])
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                                'nps',
                                !_ctx.tsNpsSummary.isFiveScore
                                    ? {
                                          up: _ctx.tsNpsSummary.change >= 0,
                                          down: _ctx.tsNpsSummary.change < 0,
                                      }
                                    : null,
                            ])
                    }, _toDisplayString(currentGroup.NPS), 3),
                    _createElementVNode("div", _hoisted_22, _toDisplayString(currentGroup.responded) + " resp ", 1)
                  ])
                ], 10, _hoisted_18)), [
                  [_vShow, _ctx.isVisibleItem(currentGroup)]
                ])
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.fields, (field) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: field }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.tsTeamGroups.filter(
                                (i) => i.fieldMapping === field
                            )[0].groupName), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedGroups, (currentGroup) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (currentGroup.field === field)
                        ? _withDirectives((_openBlock(), _createElementBlock("tr", {
                            key: field + currentGroup.group,
                            class: _normalizeClass({
                            'gl-group': true,
                            'gl-grid-hover':
                                currentGroup.group === _ctx.tsGridHoverGroup,
                            'selected-leaf': _ctx.isSelectedLeaf(currentGroup),
                        }),
                            onClick: ($event: any) => (_ctx.selectGroup(currentGroup))
                          }, [
                            _createElementVNode("td", _hoisted_25, _toDisplayString(currentGroup.group), 1),
                            _createElementVNode("td", _hoisted_26, [
                              _createVNode(_component_NPSBar, {
                                nps: Number(currentGroup.NPS),
                                min: Number(_ctx.tsGroupSummary.minNPS),
                                max: Number(_ctx.tsGroupSummary.maxNPS),
                                average: Number(_ctx.tsGroupSummary.averageNPS)
                              }, null, 8, ["nps", "min", "max", "average"])
                            ]),
                            _createElementVNode("td", _hoisted_27, [
                              _createElementVNode("div", {
                                class: _normalizeClass([
                                    'nps',
                                    !_ctx.tsNpsSummary.isFiveScore
                                        ? {
                                              up: _ctx.tsNpsSummary.change >= 0,
                                              down: _ctx.tsNpsSummary.change < 0,
                                          }
                                        : null,
                                ])
                              }, _toDisplayString(currentGroup.NPS), 3),
                              _createElementVNode("div", _hoisted_28, _toDisplayString(currentGroup.responded) + " resp ", 1)
                            ])
                          ], 10, _hoisted_24)), [
                            [_vShow, _ctx.isVisibleItem(currentGroup)]
                          ])
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ], 64))
              }), 128)),
          (_ctx.emptyList)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _hoisted_31))
            : _createCommentVNode("", true)
        ]),
        (!!_ctx.tsLoadingTeamGroupSummary)
          ? (_openBlock(), _createBlock(_component_Loading, {
              key: 0,
              loading: ""
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}